import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { ExportWrapper } from '@/containers/export/ExportWrapper'
import { SidebarProvider } from '@/context/SidebarContext'
import { useAvailableProducts } from '@/hooks/useProducts'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { ExportForm } from 'BrokerTsLib/src/containers'
import { ExportGroup } from 'BrokerTsLib/src/enums'

export const ExportsPage = () => {
  const products = useAvailableProducts()

  return (
    <SidebarProvider>
      <PageWrapper
        header={<DashboardHeader title="Exporty" />}
        sidebar={products.length > 1 ? <Sidebar /> : undefined}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
          },
        }}
      >
        <ExportWrapper>
          <ExportForm group={ExportGroup.All} />
        </ExportWrapper>
      </PageWrapper>
    </SidebarProvider>
  )
}
